import { render, staticRenderFns } from "./TaxReturnReservesReductionSection.vue?vue&type=template&id=6eb9ccde&scoped=true&"
import script from "./TaxReturnReservesReductionSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnReservesReductionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb9ccde",
  null
  
)

export default component.exports